import React, { useState, useRef, useMemo } from 'react'
import classNames from 'classnames'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { Toast } from 'primereact/toast'
import { Button } from 'primereact/button'
import { FileUpload } from 'primereact/fileupload'
import { Toolbar } from 'primereact/toolbar'
import { Dialog } from 'primereact/dialog'
import { InputText } from 'primereact/inputtext'
import { Dropdown } from 'primereact/dropdown'
import { Tag } from 'primereact/tag'
import { Checkbox } from 'primereact/checkbox'
import { IconField } from 'primereact/iconfield'
import { InputIcon } from 'primereact/inputicon'
import { InputSwitch } from 'primereact/inputswitch'
import { Slider } from 'primereact/slider'
import { TabView, TabPanel } from 'primereact/tabview'
import { TreeSelect } from 'primereact/treeselect';
import { Skeleton } from 'primereact/skeleton';
import { InfoEntry } from '../components/InfoEntry';
import moment from 'moment';
import * as R from 'ramda'
import { formatISODate, formatUTCTime } from '../utils/format'
import {
  useQuery,
  useMutation,
  useQueryClient,
} from '@tanstack/react-query'
import {
  listAllCompaniesRequest,
  listAllScalesRequest,
  createScaleRequest,
  patchScaleRequest,
  getScaleBySerialNumberRequest,
  uploadScaleUndistortionFileRequest,
  listAllTailscaleStatusRequest,
 } from '../apis/calyxSaaSDashboardAPI'
import axios from 'axios'
import { StatusCodes } from 'http-status-codes';
import { useStore } from '../stores/GlobalStore'
import { BatchAdjustCameraSettingsButton } from '../components/BatchAdjustCameraSettingsButton';
import { ScaleDownlinkButton } from '../components/ScaleDownlinkButton';
import { ScaleLatestImageDialog } from '../components/ScaleLatestImageDialog';
import { useScaleStatusQueries } from './scales/useScaleStatusQueries';

const DATA_COLLECTION_MODES = ['DataCollection', 'DataCollectionAndBirdOnScaleVisionBased', 'DataCollectionAndBirdOffScaleVisionBased'];
const VISION_BASED_MODES = ['DataCollectionAndBirdOnScaleVisionBased', 'DataCollectionAndBirdOffScaleVisionBased'];

export const CrudCayxScales = () => {
  const emptyScale = {
    serialNumber: '',
    companyId: '',
    businessId: '',
    farmId: '',
    houseId: ''
  }

  const queryClient = useQueryClient()
  const [selectedCompany, setSelectedCompany] = useState(null)
  const [selectedBu, setSelectedBu] = useState(null)
  const [selectedFarm, setSelectedFarm] = useState(null)
  const [selectedHouse, setSelectedHouse] = useState(null)
  const [uploadUndistortionMatrixFilesDialogVisibility, setUploadUndistortionMatrixFilesDialogVisibility] = useState(false)
  const [isCreateScaleAsNeededChecked, setCreateScaleAsNeededChecked] = useState(false)
  const [createOrEditScaleDialogVisibility, setcreateOrEditScaleDialogVisibility] = useState(false)
  const [isCreateScaleMode, setIsCreateScaleMode] = useState(false)
  const [deleteScaleDialogVisibility, setDeleteScaleDialogVisibility] = useState(false)
  const [scaleDetailDialog, setScaleDetailDialog] = useState(false)
  const [scaleLatestImageDialogVisibility, setScaleLatestImageDialogVisibility] = useState(false);
  const [focusedScale, setFocusedScale] = useState(emptyScale)
  const [selectedScales, setSelectedScales] = useState([])
  const [submitted, setSubmitted] = useState(false)
  const [unitNodeKeySelection, setUnitNodeKeySelection] = useState(null);
  const [globalFilter, setGlobalFilter] = useState(null)
  const [autoRefreshMode, setAutoRefreshMode] = useState(false);
  const toast = useRef(null)
  const dt = useRef(null)
  const { state, dispatch } = useStore()
  let companyMap, companyDropdown, buDropdown, farmDropdown, houseDropdown

  const allCompaniesQuery = useQuery(['list', 'companies'], () => {
    return listAllCompaniesRequest()
  }, {
    refetchOnWindowFocus: false,
    retry: 0,
    onSuccess: (companies) => {
    },
    onError: (err) => {
      if (axios.isAxiosError(err)) {
        if (err?.response?.status === StatusCodes.UNAUTHORIZED || err?.response?.status === StatusCodes.FORBIDDEN) {
          let countDownSecond = 3;
          toast.current.show({ severity: 'error', summary: `Session expired, going to logout in ${countDownSecond} seconds... Please login again`, life: 3000 });
          setInterval(() => {
            countDownSecond--;
            if (countDownSecond <= 0) {
              dispatch({
                type: 'LOGOUT',
              })
            }
          }, 1000);
        } else if (err?.response?.status === StatusCodes.INTERNAL_SERVER_ERROR) {
          toast.current.show({ severity: 'error', summary: 'Internal server error, please try again later', life: 5000 });
        } else {
          toast.current.show({ severity: 'error', summary: `Unkown Error, status code: ${err?.response?.status}`, life: 5000 });
        }
      } else {
        toast.current.show({ severity: 'error', summary: 'Unkown Error', life: 5000 });
      }
    }
  })
  companyMap = allCompaniesQuery?.data?.reduce((acc, c) => ({ ...acc, [c.id]: c }), {}) || {}
  companyDropdown = Object.keys(companyMap).map(cid => ({ label: companyMap[cid].name, value: companyMap[cid].id }))

  const allScalesQuery = useQuery(['list', 'scales'], () => {
    return listAllScalesRequest()
  }, {
    refetchOnWindowFocus: false,
    retry: 0,
    enabled: !!companyMap,
    onError: (err) => {
      if (axios.isAxiosError(err)) {
        if (err?.response?.status === StatusCodes.UNAUTHORIZED || err?.response?.status === StatusCodes.FORBIDDEN) {
          let countDownSecond = 3;
          toast.current.show({ severity: 'error', summary: `Session expired, going to logout in ${countDownSecond} seconds... Please login again`, life: 3000 });
          setInterval(() => {
            countDownSecond--;
            if (countDownSecond <= 0) {
              dispatch({
                type: 'LOGOUT',
              })
            }
          }, 1000);
        } else if (err?.response?.status === StatusCodes.INTERNAL_SERVER_ERROR) {
          toast.current.show({ severity: 'error', summary: 'Internal server error, please try again later', life: 5000 });
        } else {
          toast.current.show({ severity: 'error', summary: `Unkown Error, status code: ${err?.response?.status}`, life: 5000 });
        }
      } else {
        toast.current.show({ severity: 'error', summary: 'Unkown Error', life: 5000 });
      }
    }
  });

  const allScales = React.useMemo(() => {
    if (allCompaniesQuery.data == null || allScalesQuery.data == null) return null;

    return allScalesQuery.data.map((scale) => {
      const { companyId, businessId, farmId, houseId } = scale;

      const company = allCompaniesQuery.data?.find((company) => company.id === companyId);
      const business = company?.businesses.find((business) => business.id === businessId);
      const farm = business?.farms.find((farm) => farm.id === farmId);
      const house = farm?.houses.find((house) => house.id === houseId);

      return {
        ...scale,
        companyName: company?.name,
        businessName: business?.name,
        farmName: farm?.name,
        houseName: house?.name,
      };
    });
  }, [allCompaniesQuery.data, allScalesQuery.data]);

  const unitTreeOptions = useMemo(() => (
    allCompaniesQuery.data?.map((company) => ({
      key: ['company', company.id].join('/'),
      label: `${company.name} (${allScales?.filter((scale) => scale.companyId === company.id).length ?? 0})`,
      icon: 'pi pi-fw pi-building',
      children: company.businesses.map((business) => ({
        key: ['business', business.id].join('/'),
        label: `${business.name ?? `(${business.type})`} (${allScales?.filter((scale) => scale.businessId === business.id).length ?? 0})`,
        icon: 'pi pi-fw pi-briefcase',
        children: business.farms.map((farm) => ({
          key: ['farm', farm.id].join('/'),
          label: `${farm.name} (${allScales?.filter((scale) => scale.farmId === farm.id).length ?? 0})`,
          icon: 'pi pi-fw pi-warehouse',
          children: farm.houses.map((house) => ({
            key: ['house', house.id].join('/'),
            label: `${house.name} (${allScales?.filter((scale) => scale.houseId === house.id).length ?? 0})`,
            icon: 'pi pi-fw pi-home',
          })),
        })),
      })),
    }))
  ), [allCompaniesQuery.data, allScales]);

  const selectedUnits = useMemo(() => (
    Object.entries(unitNodeKeySelection ?? {})
      .filter(([nodeKey, { checked }]) => checked)
      .map(([nodeKey, { checked }]) => {
        const [unitType, unitId] = nodeKey.split('/');

        return {
          type: unitType,
          id: unitId,
        };
      })
  ), [unitNodeKeySelection]);

  const selectHouseIdsSet = useMemo(() => (
    new Set(
      selectedUnits
        .filter((unit) => unit.type === 'house')
        .map((unit) => unit.id)
    )
  ), [selectedUnits]);

  const filteredScales = useMemo(() => {
    if (allScales == null) return null;

    if (selectedUnits.length === 0) return allScales;

    return allScales.filter((scale) => selectHouseIdsSet.has(scale.houseId));
  }, [allScales, selectHouseIdsSet, selectedUnits.length]);

  const {
    allLatestAIEyeStatusDataQuery,
    allLatestLoadCellWeightDataQuery,
    allRecentLoadCellWeightSummaryQuery,
    allLatestAIEyeImageCatalogQuery,
  } = useScaleStatusQueries(autoRefreshMode);
  // Tailscale 這支太慢，不參與 Auto-Refresh
  const allTailscaleStatusQuery = useQuery(
    ['allTailscaleStatus'],
    () => listAllTailscaleStatusRequest(),
  );

  const latestAIEyeStatusDataMap = React.useMemo(
    () => new Map(
      (allLatestAIEyeStatusDataQuery.data ?? []).map((latestAIEyeStatusData) => [
        latestAIEyeStatusData.deviceSerialNumber,
        latestAIEyeStatusData,
      ])
    ),
    [allLatestAIEyeStatusDataQuery.data],
  );
  const latestLoadCellWeightDataMap = React.useMemo(
    () => new Map(
      (allLatestLoadCellWeightDataQuery.data ?? []).map((latestLoadCellWeightData) => [
        latestLoadCellWeightData.deviceSerialNumber,
        latestLoadCellWeightData,
      ])
    ),
    [allLatestLoadCellWeightDataQuery.data],
  );
  const recentLoadCellWeightSummaryMap = React.useMemo(
    () => new Map(
      (allRecentLoadCellWeightSummaryQuery.data ?? []).map((recentLoadCellWeightSummary) => [
        recentLoadCellWeightSummary.deviceSerialNumber,
        recentLoadCellWeightSummary,
      ])
    ),
    [allRecentLoadCellWeightSummaryQuery.data],
  );
  const latestAIEyeImageCatalogMap = React.useMemo(
    () => new Map(
      (allLatestAIEyeImageCatalogQuery.data ?? []).map((latestAIEyeImageCatalog) => [
        latestAIEyeImageCatalog.deviceSerialNumber,
        latestAIEyeImageCatalog,
      ])
    ),
    [allLatestAIEyeImageCatalogQuery.data],
  );
  const tailscaleStatusMap = React.useMemo(
    () => new Map(
      (allTailscaleStatusQuery.data ?? []).map((tailscaleStatus) => [
        tailscaleStatus.deviceSerialNumber,
        tailscaleStatus,
      ])
    ),
    [allTailscaleStatusQuery.data],
  );

  const createScaleMutation = useMutation(requestBody => {
    return createScaleRequest(requestBody)
  },
    {
      onSuccess: (createdScale) => {
        toast.current.show({ severity: 'success', summary: 'Success', detail: 'New scale has been saved', life: 3000 });

        queryClient.setQueryData(['list', 'scales'], (staleScales) => {
          return [createdScale, ...staleScales]
        });

        hideCreateOrEditScaleDialog();
      },
      onError: (err) => {
        if (axios.isAxiosError(err)) {
          if (err?.response?.status === StatusCodes.UNAUTHORIZED || err?.response?.status === StatusCodes.FORBIDDEN) {
            let countDownSecond = 3;
            toast.current.show({ severity: 'error', summary: `Session expired, going to logout in ${countDownSecond} seconds... Please login again`, life: 3000 });
            setInterval(() => {
              countDownSecond--;
              if (countDownSecond <= 0) {
                dispatch({
                  type: 'LOGOUT',
                })
              }
            }, 1000);
          } else if (err?.response?.status === StatusCodes.BAD_REQUEST) {
            toast.current.show({ severity: 'error', summary: err.response?.data?.message, life: 5000 });
          } else if (err?.response?.status === StatusCodes.INTERNAL_SERVER_ERROR) {
            toast.current.show({ severity: 'error', summary: 'Internal server error, please try again later', life: 5000 });
          } else {
            toast.current.show({ severity: 'error', summary: `Unkown Error, status code: ${err?.response?.status}`, life: 5000 });
          }
        } else {
          toast.current.show({ severity: 'error', summary: 'Unkown Error', life: 5000 });
        }
      }
  })

  const patchScaleMutation = useMutation(patchScaleOption => {
    // we still need to provide some valid ObjectId to pass the request validation if originalHouseId is nullish
    return patchScaleRequest(patchScaleOption.originalHouseId ?? '000000000000000000000000', patchScaleOption.serialNumber, patchScaleOption.requestBody)
  },
    {
      onSuccess: (updatedScale) => {
        toast.current.show({ severity: 'success', summary: 'Success', detail: 'Selected scale has been updated', life: 3000 });

        queryClient.setQueryData(['list', 'scales'], (staleScales) => {
          return staleScales.map((staleScale) => staleScale.id === updatedScale.id ? updatedScale : staleScale)
        });

        hideCreateOrEditScaleDialog();
      },
      onError: (err) => {
        if (axios.isAxiosError(err)) {
          if (err?.response?.status === StatusCodes.UNAUTHORIZED || err?.response?.status === StatusCodes.FORBIDDEN) {
            let countDownSecond = 3;
            toast.current.show({ severity: 'error', summary: `Session expired, going to logout in ${countDownSecond} seconds... Please login again`, life: 3000 });
            setInterval(() => {
              countDownSecond--;
              if (countDownSecond <= 0) {
                dispatch({
                  type: 'LOGOUT',
                })
              }
            }, 1000);
          } else if (err?.response?.status === StatusCodes.BAD_REQUEST) {
            toast.current.show({ severity: 'error', summary: err.response?.data?.message, life: 5000 });
          } else if (err?.response?.status === StatusCodes.INTERNAL_SERVER_ERROR) {
            toast.current.show({ severity: 'error', summary: 'Internal server error, please try again later', life: 5000 });
          } else {
            toast.current.show({ severity: 'error', summary: `Unkown Error, status code: ${err?.response?.status}`, life: 5000 });
          }
        } else {
          toast.current.show({ severity: 'error', summary: 'Unkown Error', life: 5000 });
        }
      }
    })

  // 先不做，因為若該house還有cycle在跑可能會出錯，未來有需要再將解綁功能打開
  // const unbindScaleMutation = useMutation(unbindScaleOption => {
  //   return unbindScaleRequest(unbindScaleOption.houseId ,unbindScaleOption.scaleId)
  // },
  //   {
  //     onSuccess: (updatedScale) => {
  //       toast.current.show({ severity: 'success', summary: 'Success', detail: 'Selected scale has been unbinded with position', life: 3000 })
  //       queryClient.setQueryData(['list', 'scales'], staleScale => {
  //         const newScales = [...staleScale]
  //         const idx = newScales.findIndex(staleScale => staleScale.id === updatedScale.id)
  //         if (idx >= 0) {
  //           updatedScale.companyName = companyMap[updatedScale.companyId].name || ''
  //           newScales[idx] = updatedScale
  //           return newScales
  //         } else {
  //           toast.current.show({ severity: 'error', summary: 'Something went wrong, please try again later', life: 5000 });
  //         }
  //       })
  //       hideDeleteScaleDialogVisibility()
  //     },
  //     onError: (err) => {
  //       if (axios.isAxiosError(err)) {
  //         if (err?.response?.status === StatusCodes.UNAUTHORIZED || err?.response?.status === StatusCodes.FORBIDDEN) {
  //           let countDownSecond = 3;
  //           toast.current.show({ severity: 'error', summary: `Session expired, going to logout in ${countDownSecond} seconds... Please login again`, life: 3000 });
  //           setInterval(() => {
  //             countDownSecond--;
  //             if (countDownSecond <= 0) {
  //               dispatch({
  //                 type: 'LOGOUT',
  //               })
  //             }
  //           }, 1000);
  //         } else if (err?.response?.status === StatusCodes.BAD_REQUEST) {
  //           toast.current.show({ severity: 'error', summary: err.response?.data?.message, life: 5000 });
  //         } else if (err?.response?.status === StatusCodes.INTERNAL_SERVER_ERROR) {
  //           toast.current.show({ severity: 'error', summary: 'Internal server error, please try again later', life: 5000 });
  //         } else {
  //           toast.current.show({ severity: 'error', summary: `Unkown Error, status code: ${err?.response?.status}`, life: 5000 });
  //         }
  //       } else {
  //         toast.current.show({ severity: 'error', summary: 'Unkown Error', life: 5000 });
  //       }
  //     }
  //   })

  const openCreateScaleDialog = () => {
    setIsCreateScaleMode(true)
    setFocusedScale(emptyScale)
    setSubmitted(false)
    setcreateOrEditScaleDialogVisibility(true)
  }

  const hideCreateOrEditScaleDialog = () => {
    setIsCreateScaleMode(false)
    setSubmitted(false)
    setcreateOrEditScaleDialogVisibility(false)
    setSelectedCompany(null)
    setSelectedBu(null)
    setSelectedFarm(null)
  }

  const hideDeleteScaleDialogVisibility = () => {
    setSubmitted(false)
    setDeleteScaleDialogVisibility(false)
  }

  const hideScaleDetailDialog = () => {
    setScaleDetailDialog(false)
  }

  const createOrEditScale = () => {
    const isValidScale = validateScale(focusedScale)
    if (!isValidScale) {
      toast.current.show({ severity: 'error', summary: 'Please fill in required fields before apply.', life: 4000 });
      return
    }
    if (isCreateScaleMode) {
      const requestBody = {
        serialNumber: focusedScale.serialNumber,
        houseId: focusedScale.houseId,
      }
      if (!requestBody.houseId) delete requestBody.houseId
      createScaleMutation.mutate(requestBody)
    } else {
      patchScaleMutation.mutate({
        originalHouseId: focusedScale.originalHouseId,
        serialNumber: focusedScale.serialNumber,
        requestBody: {
          newHouseId: focusedScale.houseId,
        }
      })
    }
  }

  const validateScale = (scale) => {
    if (
      scale?.serialNumber
    ) {
      return true
    } else {
      return false
    }
  }

  const editScale = (scale) => {
    setFocusedScale({ ...scale, originalHouseId: scale.houseId })
    const scaleDedicatedCompany = companyMap[scale?.companyId]
    setSelectedCompany(scaleDedicatedCompany)
    const scaleDedicatedBusiness = scaleDedicatedCompany?.businesses?.find(business => business?.id === scale?.businessId)
    setSelectedBu(scaleDedicatedBusiness)
    const scaleDedicatedFarm = scaleDedicatedBusiness?.farms?.find(farm => farm?.id === scale?.farmId)
    setSelectedFarm(scaleDedicatedFarm)
    const scaleDedicatedHouse = scaleDedicatedFarm?.houses?.find(house => house?.id === scale?.houseId)
    setSelectedHouse(scaleDedicatedHouse)
    setcreateOrEditScaleDialogVisibility(true)
  }

  const showScaleDetail = (scale) => {
    setFocusedScale(scale)
    setScaleDetailDialog(true)
  }

  const showScaleLatestImage = (scale) => {
    setFocusedScale(scale)
    setScaleLatestImageDialogVisibility(true)
  }

  const exportCSV = () => {
    dt.current.exportCSV()
  }

  const onInputChange = (e, name) => {
    const id = e.target.value
    if (name === 'companyId') {
      setSelectedCompany(companyMap[id])
      setSelectedBu(null)
      setSelectedFarm(null)
      setSelectedHouse(null)
    }
    if (name === 'businessId') {
      setSelectedBu(selectedCompany?.businesses?.find(business => business?.id === id))
      setSelectedFarm(null)
      setSelectedHouse(null)
    }
    if (name === 'farmId') {
      setSelectedFarm(selectedBu?.farms?.find(farm => farm?.id === id))
      setSelectedHouse(null)
    }
    if (name === 'houseId') {
      setSelectedHouse(selectedFarm?.houses?.find(house => house?.id === id))
    }
    const val = (e.target && e.target.value) || ''
    const _scale = { ...focusedScale }
    _scale[`${name}`] = val

    setFocusedScale(_scale)
  }

  buDropdown = selectedCompany?.businesses?.map(bu => ({ label: bu.name ?? bu.type, value: bu.id }))
  farmDropdown = selectedBu?.farms?.map(farm => ({ label: farm.name, value: farm.id }))
  houseDropdown = selectedFarm?.houses?.map(house => ({ label: house.name, value: house.id }))

  const unbindScale = (scale) => {
    setFocusedScale({ ...scale })
    setDeleteScaleDialogVisibility(true)
  }

  // 先不做，因為若該house還有cycle在跑可能會出錯，未來有需要再將解綁功能打開
  // const confirmUnbindScale = () => {
  //   const requestBody = { ...focusedScale }
  //   const unbindScaleOption = {
  //     houseId: requestBody.houseId,
  //     scaleId: requestBody.id
  //   }
  //   unbindScaleMutation.mutate(unbindScaleOption)
  // }

  const leftToolbarTemplate = () => {
    return (
      <>
        <div className='my-2 flex align-items-center gap-3'>
          <Button label='New' icon='pi pi-plus' className='p-button-success mr-2' data-test-id='createNewScale' onClick={openCreateScaleDialog} disabled />
          <span className='text-500'>Read-only: scale write actions are disabled here — manage scales in DataOps Lab</span>
        </div>
      </>
    )
  }

  const rightToolbarTemplate = () => {
    return (
      <>
        <label className="inline-flex align-items-center gap-2 mr-3 cursor-pointer">
          <span className={classNames(["font-semibold", { "text-blue-500": autoRefreshMode }])}>
            Auto-Refresh
          </span>
          <InputSwitch checked={autoRefreshMode} onChange={(e) => setAutoRefreshMode(e.value)} />
        </label>
        <FileUpload mode='basic' accept='image/*' maxFileSize={1000000} label='Import' chooseLabel='Import' className='mr-2 inline-block' />
        <Button label='Export' icon='pi pi-upload' className='p-button-help' onClick={exportCSV} />
      </>
    )
  }

  const serialNumberBodyTemplate = (rowData) => {
    const { companyName, businessName, farmName, houseName, houseId } = rowData;

    return (
      <>
        <span className='p-column-title'>Serial Number</span>
        <div className="flex flex-column gap-3">

          {/* Location */}
          {houseId != null ? (
            <div className="flex flex-wrap align-items-center gap-1 text-sm text-gray-500">
              {[
                companyName,
                businessName,
                farmName,
                houseName,
              ].filter((name) => name != null).map((name, i) => (
                <span className="flex align-items-center white-space-nowrap gap-1" key={i}>
                  {i !== 0 ? <i className="pi pi-angle-right" /> : null}
                  <span>{name}</span>
                </span>
              ))}
            </div>
          ) : null}

          {/* Serial Number */}
          <div>
            <code className="text-lg">{rowData.serialNumber}</code>
          </div>
        </div>
      </>
    )
  }

  const cameraSettingsTemplate = (rowData) => {
    const { dataProcessingMode } = rowData;

    const isDataCollectionMode = DATA_COLLECTION_MODES.includes(dataProcessingMode);
    const isVisualMethodMode = ['CentralAreaCoverage', 'VerticalCoverage', 'DataCollectionAndBirdOnScaleVisionBased', 'DataCollectionAndBirdOffScaleVisionBased'].includes(dataProcessingMode);
    const isVisionBasedMode = VISION_BASED_MODES.includes(dataProcessingMode);

    function toEnabledString(bool) {
      return (
        bool === true ? 'Enabled' :
        bool === false ? 'Disabled' :
        bool
      );
    }

    return (
      <div className="flex flex-column align-items-start gap-2">
        <InfoEntry
          severity={
            !rowData.hasUndistortionMatrixFile ? 'warning' :
            'info'
          }
          icon="pi pi-file-check"
        >
          Undistortion Matrix File {rowData.hasUndistortionMatrixFile ? 'attached' : 'not attached'}
        </InfoEntry>
        <InfoEntry
          severity={
            !isDataCollectionMode ? 'secondary' :
            !rowData.hasScalePanAnnotations ? 'warning' :
            'info'
          }
          icon="pi pi-pen-to-square"
        >
          Scale Pan Annotations {rowData.hasScalePanAnnotations ? 'attached' : 'not attached'}
        </InfoEntry>
        <InfoEntry
          severity={rowData.dataProcessingMode == null ? 'warning' : 'info'}
          icon="pi pi-microchip"
        >
          Data Processing Mode: {rowData.dataProcessingMode ?? 'Not Configured'}
        </InfoEntry>
        <InfoEntry
          severity={rowData.cameraMode == null ? 'warning' : 'info'}
          icon="pi pi-camera"
        >
          Camera Mode: {rowData.cameraMode ?? 'Not Configured'}
        </InfoEntry>
        <InfoEntry
          severity={
            rowData.enableDataCollection == null ? 'warning' :
            !isDataCollectionMode ? 'secondary' :
            !rowData.enableDataCollection ? 'warning' :
            'info'
          }
          icon="pi pi-chart-scatter"
        >
          Data Collection: {toEnabledString(rowData.enableDataCollection) ?? 'Not Configured'}
        </InfoEntry>
        <InfoEntry
          severity={
            rowData.enableEstimateWeightByCV == null ? 'warning' :
            !isVisualMethodMode ? 'secondary' :
            !rowData.enableEstimateWeightByCV ? 'warning' :
            'info'
          }
          icon="pi pi-eye"
        >
          Visual Method: {toEnabledString(rowData.enableEstimateWeightByCV) ?? 'Not Configured'}
        </InfoEntry>
        <InfoEntry
          severity={
            !isVisionBasedMode ? 'secondary' :
            rowData.mixedModeVisionBasedIntervalInSeconds == null ? 'warning' :
            'info'
          }
          icon="pi pi-clock"
        >
          Vision Based Interval: {rowData.mixedModeVisionBasedIntervalInSeconds != null ? `${rowData.mixedModeVisionBasedIntervalInSeconds}s` : 'Not Configured'}
        </InfoEntry>
        <InfoEntry
          severity={rowData.installHeight == null ? 'secondary' : 'info'}
          icon="pi pi-arrows-v"
        >
          Install Height: {rowData.installHeight != null ? `${rowData.installHeight} m` : 'Not Configured'}
        </InfoEntry>
      </div>
    )
  }

  const statusTemplate = (rowData) => {
    const { serialNumber, dataProcessingMode } = rowData;

    const is260CmModel = /^.D/.test(serialNumber)
    const cameraHeightThreshold = !is260CmModel ? { min: 197_0, max: 210_0 } : { min: 257_0, max: 270_0 };

    const isDataCollectionMode = DATA_COLLECTION_MODES.includes(dataProcessingMode);

    const latestAIEyeStatusData = latestAIEyeStatusDataMap.get(serialNumber);
    const latestLoadCellWeightData = latestLoadCellWeightDataMap.get(serialNumber);
    const recentLoadCellWeightSummary = recentLoadCellWeightSummaryMap.get(serialNumber);
    const latestAIEyeImageCatalog = latestAIEyeImageCatalogMap.get(serialNumber);
    const tailscaleStatus = tailscaleStatusMap.get(serialNumber);

    const { cpu, disk, cameraPosition, network, networkTraffic, mainProgram, pendingImages, powerOnReset, photoCapture, systemEnv } = latestAIEyeStatusData ?? {};
    const { weight, calibrationOption } = latestLoadCellWeightData ?? {};
    const { imageFileName } = latestAIEyeImageCatalog ?? {};

    const currentTime = new Date();
    const latestAIEyeStatusDataTime = latestAIEyeStatusData != null ? new Date(latestAIEyeStatusData.messageAt) : null;
    const latestLoadCellWeightDataTime = latestLoadCellWeightData != null ? new Date(latestLoadCellWeightData.timeStamp * 1000) : null;
    const latestAIEyeImageCatalogTime = latestAIEyeImageCatalog != null ? new Date(latestAIEyeImageCatalog.imageTakenDate) : null;
    const lastMainProgramHeartbeatTime = mainProgram != null ? new Date(mainProgram.lastHeartbeatTime) : null;
    const oldestPendingImageTime = pendingImages?.oldestImageTime != null ? new Date(pendingImages.oldestImageTime) : null;
    const newestPendingImageTime = pendingImages?.newestImageTime != null ? new Date(pendingImages.newestImageTime) : null;
    const tailscaleLastSeenTime = tailscaleStatus?.lastSeen != null ? new Date(tailscaleStatus.lastSeen) : null;

    const SECOND = 1000;
    const MINUTE = 60 * SECOND;
    const HOUR = 60 * MINUTE;

    function isOutdated(
      /** @type {Date} */ date,
      /** @type {number} */ thresholdMs,
      /** @type {Date} */ referenceDate = currentTime,
    ) {
      return (referenceDate - date) > thresholdMs;
    }

    const isMainProgramActive = (
      latestAIEyeStatusDataTime != null && lastMainProgramHeartbeatTime != null
        ? !isOutdated(lastMainProgramHeartbeatTime, 5 * MINUTE, latestAIEyeStatusDataTime)
        : null
    );

    const KiB = 1024;
    const MiB = 1024 * KiB;

    return (
      <div className="flex flex-column gap-2">
        <InfoEntry
          severity={
            !isDataCollectionMode ? 'secondary' :
            latestLoadCellWeightData == null ? 'warning' :
            isOutdated(latestLoadCellWeightDataTime, 1 * HOUR) ? 'warning' :
            'info'
          }
          icon="pi pi-clock"
        >
          Latest Loadcell Weight: {
            latestLoadCellWeightData != null
              ? formatISODate(latestLoadCellWeightDataTime)
              : 'No Data'
          }
        </InfoEntry>
        <div className="flex flex-column gap-2 pl-4">
          <InfoEntry
            severity={
              !isDataCollectionMode ? 'secondary' :
              weight == null ? 'secondary' :
              weight < -500 ? 'warning' :
              'info'
            }
            icon="pi pi-gauge"
          >
            Weight: {
              weight != null
                ? `${weight}g`
                : 'No Data'
            }
          </InfoEntry>
          <InfoEntry
            severity={
              !isDataCollectionMode ? 'secondary' :
              calibrationOption == null ? 'secondary' :
              'info'
            }
            icon="pi pi-sliders-h"
          >
            Calibration Option: {
              calibrationOption != null
                ? `(operator = ${calibrationOption.operator}, value = ${calibrationOption.value})`
                : 'No Data'
            }
          </InfoEntry>
        </div>

        <InfoEntry
          severity={
            !isDataCollectionMode ? 'secondary' :
            recentLoadCellWeightSummary == null ? 'secondary' :
            'info'
          }
          icon="pi pi-clock"
        >
          Recent Loadcell Weight Summary: {
            recentLoadCellWeightSummary != null
              ? `(from ${moment.duration(-recentLoadCellWeightSummary.receivedTimeWindow).humanize(true)} to now)`
              : 'No Data'
          }
        </InfoEntry>
        <div className="flex flex-column gap-2 pl-4">
          <InfoEntry
            severity={
              !isDataCollectionMode ? 'secondary' :
              recentLoadCellWeightSummary == null ? 'secondary' :
              recentLoadCellWeightSummary.receivedTimeWindow === 0 ? 'warning' :
              recentLoadCellWeightSummary.receivedCount / recentLoadCellWeightSummary.receivedTimeWindow < (3600 * 0.8) / HOUR ? 'warning' :
              'info'
            }
            icon="pi pi-download"
          >
            Received Count: {
              recentLoadCellWeightSummary != null
                ? `${recentLoadCellWeightSummary.receivedCount} (${recentLoadCellWeightSummary.receivedTimeWindow !== 0 ? Number(recentLoadCellWeightSummary.receivedCount / (recentLoadCellWeightSummary.receivedTimeWindow / MINUTE)).toFixed(0) : 'N/A'} per minute)`
                : 'No Data'
            }
          </InfoEntry>
          <InfoEntry
            severity={
              !isDataCollectionMode ? 'secondary' :
              recentLoadCellWeightSummary == null ? 'secondary' :
              recentLoadCellWeightSummary.weighedTimeWindow === 0 ? 'warning' :
              recentLoadCellWeightSummary.weighedCount / recentLoadCellWeightSummary.weighedTimeWindow < (3600 * 0.8) / HOUR ? 'warning' :
              'info'
            }
            icon="pi pi-gauge"
          >
            Valid Weighed Count: {
              recentLoadCellWeightSummary != null
                ? `${recentLoadCellWeightSummary.weighedCount} (${recentLoadCellWeightSummary.weighedTimeWindow !== 0 ? Number(recentLoadCellWeightSummary.weighedCount / (recentLoadCellWeightSummary.weighedTimeWindow / MINUTE)).toFixed(0) : 'N/A'} per minute)`
                : 'No Data'
            }
          </InfoEntry>
        </div>

        <InfoEntry
          severity={
            latestAIEyeImageCatalog == null ? 'warning' :
            isOutdated(latestAIEyeImageCatalogTime, 1 * HOUR) ? 'warning' :
            'info'
          }
          icon="pi pi-clock"
        >
          Latest Raw Image: {
            latestAIEyeImageCatalog != null
              ? formatISODate(latestAIEyeImageCatalogTime)
              : 'No Data'
          }
        </InfoEntry>
        {false && <div className="flex flex-column gap-2 pl-4">
          <InfoEntry
            severity={
              imageFileName == null ? 'secondary' :
              'info'
            }
            icon="pi pi-image"
          >
            Image File: {
              imageFileName != null
                ? imageFileName
                : 'No Data'
            }
          </InfoEntry>
        </div>}

        <InfoEntry
          severity={
            latestAIEyeStatusData == null ? 'warning' :
            isOutdated(latestAIEyeStatusDataTime, 1 * HOUR) ? 'warning' :
            'info'
          }
          icon="pi pi-clock"
        >
          Latest Regular Report: {
            latestAIEyeStatusData != null
              ? formatISODate(latestAIEyeStatusDataTime)
              : 'No Data'
          }
        </InfoEntry>
        <div className="flex flex-column gap-2 pl-4">
          <InfoEntry
            severity={cpu != null ? 'info' : 'secondary'}
            icon="pi pi-microchip"
          >
            CPU Usage: {
              cpu != null
                ? `${cpu.percentageUtilization}% (${cpu.temperature}°C)`
                : 'No Data'
            }
          </InfoEntry>
          <InfoEntry
            severity={
              disk == null ? 'secondary' :
              disk.usedSpace / (disk.usedSpace + disk.availableSpace) >= 90 / 100 ? 'warning' :
              'info'
            }
            icon="pi pi-database"
          >
            Disk Usage: {
              disk != null
                ? `${disk.usedSpace} MiB / ${disk.usedSpace + disk.availableSpace} MiB (${(100 * disk.usedSpace / (disk.usedSpace + disk.availableSpace)).toFixed(1)}%)`
                : 'No Data'
            }
          </InfoEntry>
          <InfoEntry
            severity={
              cameraPosition == null ? 'secondary' :
              cameraPosition.height != null && (cameraPosition.height < cameraHeightThreshold.min || cameraPosition.height > cameraHeightThreshold.max) ? 'warning' :
              'info'
            }
            icon="pi pi-camera"
          >
            Camera Position: {
              cameraPosition != null
                ? `(height = ${cameraPosition.height != null ? `${(cameraPosition.height / 10).toFixed(2)}cm` : 'N/A'}, tilt = (x = ${cameraPosition.tiltAngle.x}°, y = ${cameraPosition.tiltAngle.y}°))`
                : 'No Data'
            }
          </InfoEntry>
          <InfoEntry
            severity={
              network == null ? 'secondary' :
              'info'
            }
            icon="pi pi-globe"
          >
            Network: {
              network != null
                ? `(interface = ${network.interface}, IP = ${network.ipAddress}, MAC = ${network.macAddress}, awsMqttIpProtocol = ${network.awsMqttIpProtocol ?? 'N/A'})`
                : 'No Data'
            }
          </InfoEntry>
          <InfoEntry
            severity={
              networkTraffic == null ? 'secondary' :
              networkTraffic.txBytes < 2 * MiB ? 'warning' :
              'info'
            }
            icon="pi pi-sort-alt"
          >
            Network Traffic: {
              networkTraffic != null
                ? `(tx = ${networkTraffic.tx}, rx = ${networkTraffic.rx}, avgRate = ${networkTraffic.avgRate})`
                : 'No Data'
            }
          </InfoEntry>
          <InfoEntry
            severity={
              pendingImages == null ? 'secondary' :
              pendingImages.imagesCount >= 1000 ? 'warning' :
              'info'
            }
            icon="pi pi-images"
          >
            Pending Images: {
              pendingImages != null
                ? `${pendingImages.imagesCount} (${oldestPendingImageTime != null ? formatUTCTime(oldestPendingImageTime) : 'N/A'} - ${newestPendingImageTime != null ? formatUTCTime(newestPendingImageTime) : 'N/A'})`
                : 'No Data'
            }
          </InfoEntry>
          <InfoEntry
            severity={
              mainProgram == null ? 'secondary' :
              !isMainProgramActive ? 'warning' :
              'info'
            }
            icon="pi pi-sync"
          >
            Main Program: {
              mainProgram != null
                ? `${isMainProgramActive ? 'Active' : 'Inactive'} (${moment.duration(moment(latestAIEyeStatusDataTime).diff(lastMainProgramHeartbeatTime)).humanize()} from last heartbeat)`
                : 'No Data'
            }
          </InfoEntry>
          <InfoEntry
            severity={
              powerOnReset == null ? 'secondary' :
              powerOnReset.enabled ? 'warning' :
              'info'
            }
            icon="pi pi-wave-pulse"
          >
            Power-on Reset: {
              powerOnReset != null
                ? `${powerOnReset.enabled ? 'ON' : 'OFF'} (reported ${moment(powerOnReset.checkedAt).fromNow()})`
                : 'No Data'
            }
          </InfoEntry>
          <InfoEntry
            severity={
              photoCapture == null ? 'secondary' :
              photoCapture.brightnessPercent == null ? 'warning' :
              'info'
            }
            icon="pi pi-camera"
          >
            Photo Capture: {
              photoCapture != null
                ? `(brightness = ${photoCapture.brightnessPercent != null ? `${photoCapture.brightnessPercent}%` : 'N/A'}, captureMode = ${photoCapture.captureMode ?? 'N/A'})`
                : 'No Data'
            }
          </InfoEntry>
          <InfoEntry
            severity={
              systemEnv == null ? 'secondary' :
              'info'
            }
            icon="pi pi-sliders-h"
          >
            {systemEnv != null ? (
              <details>
                <summary className="cursor-pointer select-none">
                  System Env: (Click to expand)
                </summary>
                <div className="flex flex-column gap-2 mt-2">
                  <InfoEntry
                    severity={
                      systemEnv.loadcellInterval == null ? 'secondary' :
                      'info'
                    }
                    icon="pi pi-sync"
                  >
                    Loadcell Interval: {
                      systemEnv.loadcellInterval != null
                        ? `${systemEnv.loadcellInterval} s`
                        : 'N/A'
                    }
                  </InfoEntry>
                  <InfoEntry
                    severity={
                      systemEnv.cameraCaptureInterval == null ? 'secondary' :
                      'info'
                    }
                    icon="pi pi-sync"
                  >
                    Camera Capture Interval: {
                      systemEnv.cameraCaptureInterval != null
                        ? `${systemEnv.cameraCaptureInterval} s`
                        : 'N/A'
                    }
                  </InfoEntry>
                  <InfoEntry
                    severity={
                      systemEnv.regularReportInterval == null ? 'secondary' :
                      'info'
                    }
                    icon="pi pi-sync"
                  >
                    Regular Report Interval: {
                      systemEnv.regularReportInterval != null
                        ? `${systemEnv.regularReportInterval} s`
                        : 'N/A'
                    }
                  </InfoEntry>
                  <InfoEntry
                    severity={
                      systemEnv.tofCalibrationOffset == null ? 'secondary' :
                      'info'
                    }
                    icon="pi pi-sliders-v"
                  >
                    <abbr title="Time of Flight">ToF</abbr> Calibration Offset: {
                      systemEnv.tofCalibrationOffset != null
                        ? `${systemEnv.tofCalibrationOffset} mm`
                        : 'N/A'
                    }
                  </InfoEntry>
                  <InfoEntry
                    severity={
                      systemEnv.ldmCalibrationOffset == null ? 'secondary' :
                      'info'
                    }
                    icon="pi pi-sliders-v"
                  >
                    <abbr title="Laser Distance Meter">LDM</abbr> Calibration Offset: {
                      systemEnv.ldmCalibrationOffset != null
                        ? `${systemEnv.ldmCalibrationOffset} mm`
                        : 'N/A'
                    }
                  </InfoEntry>
                  <InfoEntry
                    severity={
                      systemEnv.imuXOffset == null ? 'secondary' :
                      'info'
                    }
                    icon="pi pi-sliders-v"
                  >
                    <abbr title="Inertial Measurement Unit">IMU</abbr> X Offset: {
                      systemEnv.imuXOffset != null
                        ? `${systemEnv.imuXOffset}°`
                        : 'N/A'
                    }
                  </InfoEntry>
                  <InfoEntry
                    severity={
                      systemEnv.imuYOffset == null ? 'secondary' :
                      'info'
                    }
                    icon="pi pi-sliders-v"
                  >
                    <abbr title="Inertial Measurement Unit">IMU</abbr> Y Offset: {
                      systemEnv.imuYOffset != null
                        ? `${systemEnv.imuYOffset}°`
                        : 'N/A'
                    }
                  </InfoEntry>
                  <InfoEntry
                    severity={
                      systemEnv.imageQuality == null ? 'secondary' :
                      'info'
                    }
                    icon="pi pi-image"
                  >
                    Image Quality: {
                      systemEnv.imageQuality != null
                        ? `${systemEnv.imageQuality}`
                        : 'N/A'
                    }
                  </InfoEntry>
                  <InfoEntry
                    severity={
                      systemEnv.ldmMode == null ? 'secondary' :
                      'info'
                    }
                    icon="pi pi-sliders-h"
                  >
                    <abbr title="Laser Distance Meter">LDM</abbr> Mode: {
                      systemEnv.ldmMode != null
                        ? `${systemEnv.ldmMode}`
                        : 'N/A'
                    }
                  </InfoEntry>
                  <InfoEntry
                    severity={
                      systemEnv.ambientLightThresholdPercent == null ? 'secondary' :
                      'info'
                    }
                    icon="pi pi-sliders-v"
                  >
                    Ambient Light Threshold: {
                      systemEnv.ambientLightThresholdPercent != null
                        ? `${systemEnv.ambientLightThresholdPercent}%`
                        : 'N/A'
                    }
                  </InfoEntry>
                  <InfoEntry
                    severity={
                      systemEnv.ths30bEnable == null ? 'secondary' :
                      'info'
                    }
                    icon="pi pi-sliders-h"
                  >
                    Temperature/Humidity Sensor: {
                      systemEnv.ths30bEnable != null
                        ? (systemEnv.ths30bEnable ? 'Enabled' : 'Disabled')
                        : 'N/A'
                    }
                  </InfoEntry>
                </div>
              </details>
            ) : (
              <>System Env: No Data</>
            )}
          </InfoEntry>
        </div>

        <InfoEntry
          severity={
            tailscaleStatus == null ? 'secondary' :
            isOutdated(tailscaleLastSeenTime, 1 * HOUR) ? 'warning' :
            'info'
          }
          icon="pi pi-clock"
        >
          Last Seen from Tailscale: {
            tailscaleStatus != null
              ? formatISODate(tailscaleLastSeenTime)
              : 'No Data'
          }
        </InfoEntry>
        <div className="flex flex-column gap-2 pl-4">
          <InfoEntry
            severity={
              tailscaleStatus == null ? 'secondary' :
              'info'
            }
            icon="pi pi-at"
          >
            IP Addresses: {
              tailscaleStatus != null
                ? [...(tailscaleStatus.addresses ?? []), tailscaleStatus.machineName].join(' / ')
                : 'No Data'
            }
          </InfoEntry>
        </div>
      </div>
    );
  }

  const remarkBodyTemplate = (rowData) => {
    return (
      <>
        <span className='p-column-title'>Remark</span>
        {rowData.remark}
      </>
    )
  }

  const actionBodyTemplate = (rowData) => {
    return (
      <div className='actions flex flex-wrap gap-2'>
        <Button tooltip='detail' icon='pi pi-info-circle' className='p-button-rounded p-button-info' data-test-id='showScaleDetail' onClick={() => showScaleDetail(rowData)} />
        <Button tooltip='edit' icon='pi pi-pencil' className='p-button-rounded p-button-success' onClick={() => editScale(rowData)} disabled />
        <Button tooltip="image" icon="pi pi-camera" rounded severity="help" onClick={() => showScaleLatestImage(rowData)} />
      </div>
    )
  }

  const connectionBodyTemplate = (rowData) => {
    if (R.isNil(rowData.positionId)) {
      return (
        <div className='actions' />
      )
    } else {
      return (
        <div className='actions'>
          <Button tooltip='unbind scale' icon='pi pi-link' className='p-button-rounded p-button-danger mt-2' data-test-id='unbindScale' onClick={() => unbindScale(rowData)} disabled />
        </div>
      )
    }
  }

  const header = (
    <div className='flex flex-wrap gap-3 justify-content-between align-items-center'>
      <h5 className='m-0 white-space-nowrap'>Manage Calyx Scales</h5>
      <div className="flex flex-wrap gap-3">
        <Button
          className={classNames({ "hidden": selectedScales.length === 0 })}
          label={`${selectedScales.length} selected scale(s)`}
          icon="pi pi-copy"
          severity="info"
          outlined
          tooltip="Copy Serial Number(s) to Clipboard"
          tooltipOptions={{ position: "top" }}
          onClick={copySelectedScaleListToClipBoard}
        />
        <TreeSelect
          value={unitNodeKeySelection}
          options={unitTreeOptions}
          className="w-full md:w-24rem"
          selectionMode="checkbox"
          filter
          showClear
          placeholder
          valueTemplate={
            <div className={classNames("flex align-items-center gap-2", { "text-blue-500": selectedUnits.length !== 0 })}>
              <InputIcon className="pi pi-fw pi-filter" />
              <span>{selectedUnits.length === 0 ? 'Filter with unit...' : `Filtered with ${selectHouseIdsSet.size} house(s)`}</span>
            </div>
          }
          onChange={(e) => setUnitNodeKeySelection(e.value)}
        />
        <IconField iconPosition="left" className="w-full md:w-16rem">
          <InputIcon className='pi pi-fw pi-search' />
          <InputText type='search' className="w-full" data-test-id='searchScale' onInput={(e) => setGlobalFilter(e.target.value)} placeholder='Search...' />
        </IconField>
      </div>
    </div>
  )

  const createOrEditScaleDialogFooter = (
    <>
      <Button label='Cancel' icon='pi pi-times' className='p-button-text' onClick={hideCreateOrEditScaleDialog} />
      <Button label='Save' icon='pi pi-check' className='p-button-text' data-test-id='savelNewScale' onClick={createOrEditScale} />
    </>
  )

  const deleteScaleDialogFooter = (
    <>
        <Button label='Cancel' icon='pi pi-times' className='p-button-text' onClick={hideDeleteScaleDialogVisibility} />
        {/* <Button label='Save' icon='pi pi-check' className='p-button-text' data-test-id='unbindScale' onClick={confirmUnbindScale} /> */}
    </>
  )

  function extractSerialNumberFromFileName(/** @type {string} */ fileName) {
    const match = fileName.match(/^camera_parameters(?<serialNumber>.+)\.npz$/);

    if (match == null) return null;

    return match.groups['serialNumber'];
  }

  async function undistortionMatrixFilesUploadHandler(/** @type {{ files: File[] }} */ { files }) {
    try {
      for (const file of files) {
        const serialNumber = extractSerialNumberFromFileName(file.name);

        if (serialNumber == null) {
          toast.current.show({ severity: 'warn', summary: 'Invalid File Name', detail: `Unable to extract Serial Number from file name: "${file.name}"`, sticky: true })
          continue
        }

        let scale = await getScaleBySerialNumberRequest({ serialNumber });

        if (scale == null) {
          if (isCreateScaleAsNeededChecked) {
            scale = await createScaleRequest({ serialNumber });
            toast.current.show({ severity: 'info', summary: 'Scale Created', detail: `Created scale with Serial Number: ${serialNumber}` })
          } else {
            toast.current.show({ severity: 'warn', summary: 'Scale Not Found', detail: `Unable to find scale with Serial Number: ${serialNumber}`, sticky: true })
            continue;
          }
        }

        await uploadScaleUndistortionFileRequest({ deviceId: scale.id, file });
        toast.current.show({ severity: 'success', summary: 'Success', detail: `File "${file.name}" uploaded to scale ${serialNumber}` })
      }
    } catch (err) {
      toast.current.show({ severity: 'error', summary: 'Unexpected Error', detail: err.toString(), sticky: true })
    }
  }

  async function copySelectedScaleListToClipBoard() {
    const csv = selectedScales.map((scale) => scale.serialNumber).join(',');

    await navigator.clipboard.writeText(csv);
  }

  return (
    <div className='grid crud-demo'>
      <div className='col-12'>
        <div className='card'>
          <Toast ref={toast} />
          <Toolbar className='mb-4' left={leftToolbarTemplate} right={rightToolbarTemplate} />

          <div className='flex flex-wrap gap-2 mb-4'>
            <Button
              label='Upload Undistortion Matrix Files'
              icon='pi pi-upload'
              className='p-button-success'
              onClick={() => setUploadUndistortionMatrixFilesDialogVisibility(true)}
              disabled
            />
            <BatchAdjustCameraSettingsButton />
            <ScaleDownlinkButton />
          </div>

          {filteredScales == null ?
            (
              <DataTable value={Array.from({ length: 10 })} className="p-datatable-striped company-table-skeleton" header={header}>
                <Column selectionMode='multiple' headerStyle={{ width: '0' }} />
                <Column header='Serial Number' body={<Skeleton />} style={{ width: '100px' }} />
                <Column header='Camera Settings' body={<Skeleton />} style={{ width: '300px' }} />
                <Column header='Status' body={<Skeleton />} style={{ width: '450px' }} />
                <Column header='Action' body={<Skeleton />} style={{ width: '0' }} />
              </DataTable>
            )
            :
            (
              <DataTable
                ref={dt} value={filteredScales} selectionMode='checkbox' selection={selectedScales} onSelectionChange={(e) => setSelectedScales(e.value)}
                dataKey='id' paginator rows={50} rowsPerPageOptions={[5, 10, 25, 50, 100]} className='datatable-responsive'
                paginatorTemplate='FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown'
                currentPageReportTemplate='Showing {first} to {last} of {totalRecords} scales'
                globalFilter={globalFilter}
                globalFilterFields={['serialNumber', 'companyName', 'businessName', 'farmName']}
                emptyMessage='No scales found.' header={header} responsiveLayout='scroll'
              >
                <Column selectionMode='multiple' headerStyle={{ width: '0' }}></Column>
                <Column header='Serial Number' body={serialNumberBodyTemplate} field='serialNumber' sortable style={{ width: '100px' }} />
                <Column header='Camera Settings' body={cameraSettingsTemplate} field='dataProcessingMode' sortable style={{ width: '300px' }} />
                <Column header='Status' body={statusTemplate} style={{ width: '450px' }} />
                <Column header='Action' body={actionBodyTemplate} style={{ width: '0' }} />
              </DataTable>
            )
          }

          <Dialog blockScroll={true} visible={createOrEditScaleDialogVisibility} style={{ width: '450px' }} header={isCreateScaleMode ? 'Create new scale' : 'Edit scale'} modal className='p-fluid' footer={createOrEditScaleDialogFooter} onHide={hideCreateOrEditScaleDialog}>
            <div className='field'>
              <label htmlFor='serialNumber'>Serial Number</label>
              <InputText
                id='serialNumber' data-test-id='typeSerialNumber' value={focusedScale.serialNumber} onChange={(e) => onInputChange(e, 'serialNumber')} required autoFocus
                disabled={focusedScale.id || createScaleMutation.isLoading || patchScaleMutation.isLoading}
                className={classNames({ 'p-invalid': submitted && !focusedScale.serialNumber })}
              />
              {!focusedScale.serialNumber && <small className='p-invalid' style={{ color: 'red' }} >Serial Number is required.</small>}
            </div>
            <div className='field' data-test-id='chooseScaleCompany'>
              <label htmlFor='company'>Company</label>
              <Dropdown
                id='company' value={focusedScale.companyId} options={companyDropdown} filter onChange={(e) => onInputChange(e, 'companyId')}
                disabled={createScaleMutation.isLoading || patchScaleMutation.isLoading}
              />
            </div>
            <div className='field' data-test-id='chooseScaleBusiness'>
              <label htmlFor='business'>Business</label>
              <Dropdown
                id='business' value={focusedScale?.businessId} options={buDropdown} onChange={(e) => onInputChange(e, 'businessId')}
                disabled={createScaleMutation.isLoading || patchScaleMutation.isLoading}
              />
            </div>
            <div className='field' data-test-id='chooseScaleFarm'>
              <label htmlFor='farm'>Farm</label>
              <Dropdown
                id='farm' value={focusedScale?.farmId} options={farmDropdown} onChange={(e) => onInputChange(e, 'farmId')}
                disabled={createScaleMutation.isLoading || patchScaleMutation.isLoading}
              />
            </div>
            <div className='field' data-test-id='chooseScaleHouse'>
              <label htmlFor='house'>House</label>
              <Dropdown
                id='house' value={focusedScale?.houseId} options={houseDropdown} onChange={(e) => onInputChange(e, 'houseId')}
                disabled={createScaleMutation.isLoading || patchScaleMutation.isLoading}
              />
            </div>
          </Dialog>

          <Dialog blockScroll={true} visible={scaleDetailDialog} style={{ width: '450px' }} header='Scale Detail' modal onHide={hideScaleDetailDialog}>
            <div className='field'>
              <label htmlFor='id' style={{ color: 'gray', fontSize: '18px', marginRight: '10px' }} >_id: </label><label>{focusedScale.id}</label>
            </div>
            <div className='field'>
              <label htmlFor='serialNumber' style={{ color: 'gray', fontSize: '18px', marginRight: '10px' }} >Serial Number: </label><label>{focusedScale.serialNumber}</label>
            </div>
            <div className='field'>
              <label htmlFor='mobile' style={{ color: 'gray', fontSize: '18px', marginRight: '10px' }} >Company: </label><label>{focusedScale.companyId}</label>
            </div>
            <div className='field'>
              <label htmlFor='businessId' style={{ color: 'gray', fontSize: '18px', marginRight: '10px' }} >businessId: </label><label>{focusedScale.businessId}</label>
            </div>
            <div className='field'>
              <label htmlFor='farmId' style={{ color: 'gray', fontSize: '18px', marginRight: '10px' }} >farmId: </label><label>{focusedScale.farmId}</label>
            </div>
            <div className='field'>
              <label htmlFor='houseId' style={{ color: 'gray', fontSize: '18px', marginRight: '10px' }} >houseId: </label><label>{focusedScale.houseId}</label>
            </div>
            <div className='field'>
              <label htmlFor='createdTime' style={{ color: 'gray', fontSize: '18px', marginRight: '10px' }} >createdTime: </label><label>{focusedScale.createdTime}</label>
            </div>
            <div className='field'>
              <label htmlFor='updatedTime' style={{ color: 'gray', fontSize: '18px', marginRight: '10px' }} >updatedTime: </label><label>{focusedScale.updatedTime}</label>
            </div>
            <div className='field'>
              <label htmlFor='lastUplinkAt' style={{ color: 'gray', fontSize: '18px', marginRight: '10px' }} >lastUplinkAt: </label><label>{focusedScale.lastUplinkAt}</label>
            </div>
          </Dialog>

          <Dialog blockScroll={true} visible={deleteScaleDialogVisibility} style={{ width: '450px' }} header={'Unbind scale confirmation?'} modal className='p-fluid' footer={deleteScaleDialogFooter} onHide={hideDeleteScaleDialogVisibility}>
          </Dialog>

          <Dialog
            visible={uploadUndistortionMatrixFilesDialogVisibility}
            header="Upload Undistortion Matrix Files"
            footer={<div />}
            style={{ width: '450px' }}
            blockScroll
            onHide={() => setUploadUndistortionMatrixFilesDialogVisibility(false)}
          >
            <FileUpload
              multiple
              accept=".npz"
              customUpload
              uploadHandler={undistortionMatrixFilesUploadHandler}
              cancelLabel="Clear All"
              emptyTemplate={() => {
                return (
                  <div
                    className="flex flex-column align-items-center justify-content-center text-gray-500 select-none"
                    style={{ minHeight: '300px' }}
                  >
                    <i className="pi pi-upload mb-4" style={{ fontSize: '2rem' }} />
                    <p>
                      You can also drag and drop files here to upload.
                    </p>
                    <p className="text-primary">
                      (Format: <code>camera_parameters<i><b>SERIAL_NUMBER</b></i>.npz</code>)
                    </p>
                  </div>
                );
              }}
              itemTemplate={(file, props) => {
                const serialNumber = extractSerialNumberFromFileName(file.name);

                return (
                  <div className="flex align-items-center gap-3 text-left">
                    <div className="flex-1 flex flex-column gap-1 overflow-hidden">
                      <Tag
                        severity={serialNumber != null ? 'info' : "danger"}
                        className="block text-center px-6"
                      >
                        <div className="text-base white-space-nowrap overflow-hidden text-overflow-ellipsis">
                          <code>{serialNumber ?? 'Invalid File Name'}</code>
                        </div>
                      </Tag>
                      <div className="white-space-nowrap overflow-hidden text-overflow-ellipsis">
                        <code>{file.name}</code>
                      </div>
                    </div>
                    <div className="flex-none">
                      <Button
                        icon="pi pi-trash"
                        className="p-button-text p-button-secondary p-button-rounded"
                        onClick={props.onRemove}
                      />
                    </div>
                  </div>
                );
              }}
            />
            <div className="mt-3">
              <label className="flex gap-2 align-items-center">
                <Checkbox
                  checked={isCreateScaleAsNeededChecked}
                  onChange={e => setCreateScaleAsNeededChecked(e.checked)}
                />
                <span>Create scale as needed</span>
              </label>
            </div>
          </Dialog>

          <ScaleLatestImageDialog
            key={focusedScale?.serialNumber}
            visible={scaleLatestImageDialogVisibility}
            targetScale={focusedScale}
            latestAIEyeStatusData={latestAIEyeStatusDataMap.get(focusedScale?.serialNumber)}
            autoRefreshMode={autoRefreshMode}
            onHide={() => setScaleLatestImageDialogVisibility(false)}
          />
        </div>
      </div>
    </div>
  )
}
